import React, { useState } from "react";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { formatBrDate } from "../../utils/formats";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFileExcel } from '@fortawesome/free-solid-svg-icons'
import { Button, useTheme } from '@mui/material';
import { tokens } from "../../theme";
const ExcelUpdater = ({ data, fileName, kitNumber, sellerName, dataEntrega, dataAcerto }) => {
    // const [file, setFile] = useState(null);

    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    const tableData = data.sort((a,b) => a.id_produto - b.id_produto).map(item => [
        item.id_produto,
        parseFloat(item["Preço"].replace(',', '.')),
        ""
    ]);

    const totalValueprods = data.reduce((acc,curr) => acc += Number(curr["Preço"].replace(',', '.')),0)

    // const handleFileChange = (e) => {
    //     setFile(e.target.files[0]);
    // };

    const handleUpdateAndDownload = async () => {
        try {
            // Fetch the Excel file from a static location in the public folder
            const response = await fetch(`${process.env.PUBLIC_URL}/assets/docs/seller_sold.xlsx`);
            if (!response.ok) throw new Error("Could not fetch the Excel file.");

            const arrayBuffer = await response.arrayBuffer();

            // Create a new workbook and load the file
            const workbook = new ExcelJS.Workbook();
            await workbook.xlsx.load(arrayBuffer);

            // Verify that the workbook has at least one worksheet
            if (workbook.worksheets.length === 0) {
                console.error("Workbook does not contain any worksheets.");
                return;
            }
            if (workbook.worksheets.length === 0) {
                console.error("Workbook does not contain any worksheets.");
                return;
            }

            // Get the worksheet by index or name (change as needed)
            const worksheet = workbook.getWorksheet("1"); // or use the name of the sheet if known (e.g., workbook.getWorksheet("Sheet1"))

            if (!worksheet) {
                console.error("Worksheet could not be loaded.");
                return;
            }

            // Update the worksheet name dynamically based on the kit number
            worksheet.name = kitNumber;

            // Change the value of cell D7 dynamically (Seller's Name)
            const sellerNameCel = worksheet.getCell('D7');
            sellerNameCel.value = sellerName;

            // Change the value of cell D8 dynamically (Data Entrega)
            const dataEntregaCel = worksheet.getCell('D8');
            dataEntregaCel.value = formatBrDate(dataEntrega);

            // Change the value of cell D9 dynamically (Data Acerto)
            const dataAcertoCel = worksheet.getCell('D9');
            dataAcertoCel.value = formatBrDate(dataAcerto);

            // Starting row for data insertion (C27 corresponds to row 27, column 3)
            let startRow = 27;
            const startColumn = 3; // Column C
            
            const totalLines = tableData?.length
            // Start iterating over tableData and inserting each row
            let count = 0 
            tableData.forEach((rowData, rowIndex) => {
                count += 1 
                // Get the previous row (the row before the one we're about to insert)
                const previousRow = worksheet.getRow(startRow + rowIndex);

                // Insert a new row at the correct position (startRow + rowIndex)
                const newRow = worksheet.insertRow(startRow + rowIndex); // Insert at the correct position

                // Check if the previous row exists and copy data and styles
                if (previousRow) {
                    previousRow.eachCell({ includeEmpty: true }, (cell, colNumber) => {
                        const newCell = newRow.getCell(colNumber); // Get the corresponding new cell

                        // Copy the cell value and style
                        newCell.value = cell.value; // Copy the value
                        newCell.style = cell.style; // Copy the style (font, borders, fill, etc.)

                        // Optionally, copy other properties like hyperlinks, data validations, etc.
                        if (cell.hyperlink) {
                            newCell.hyperlink = cell.hyperlink;
                        }
                        if (cell.dataValidation) {
                            newCell.dataValidation = cell.dataValidation;
                        }
                    });
                }
                
                // Now update the values for the current row (if necessary)
                rowData.forEach((value, colIndex, index) => {
                    const cell = newRow.getCell(startColumn + colIndex); // Start at column 3 (C)
                    const borderLeftCell = newRow.getCell(startColumn -1); // Start at column 3 (C)
                    borderLeftCell.border = {
                        left: {style:'dotted', color: {argb:'FF000000'}},
                    }
                    const borderRightCell = newRow.getCell(startColumn +5); // Start at column 3 (C)
                    borderRightCell.border = {
                        right: {style:'dotted', color: {argb:'FF000000'}},
                    }
                    cell.value = value; // Set the value dynamically
                    cell.alignment = {
                        horizontal: 'center', // Horizontal center alignment
                        vertical: 'middle',   // Vertical center alignment
                    };
                    if(colIndex === 0){
                        cell.border = {
                            top: {style:'dotted', color: {argb:'FF000000'}},
                            left: {style:'medium', color: {argb:'FF000000'}},
                            bottom: {style: count === totalLines ? 'medium' : 'dotted', color: {argb:'FF000000'}},
                            right: {style:'dotted', color: {argb:'FF000000'}},
                        }
                    } else if(colIndex === 2){
                        cell.border = {
                            top: {style:'dotted', color: {argb:'FF000000'}},
                            right: {style:'medium', color: {argb:'FF000000'}},
                            bottom: {style: count === totalLines ? 'medium' : 'dotted', color: {argb:'FF000000'}},
                        }
                    } else{
                        cell.border = {
                            top: {style:'dotted', color: {argb:'FF000000'}},
                            right: {style:'dotted', color: {argb:'FF000000'}},
                            bottom: {style: count === totalLines ? 'medium' : 'dotted', color: {argb:'FF000000'}},
                        }
                    }
                });
            });
            

            const totalProdsText = worksheet.getCell(`C${startRow+totalLines}`);
            totalProdsText.value = 'TOTAL'
            totalProdsText.font = {
                bold: true
            }
            totalProdsText.alignment = { 
                vertical: 'middle', horizontal: 'center' 
            };
            
            const totalProdsValue = worksheet.getCell(`D${startRow+totalLines}`);
            totalProdsValue.value = totalValueprods
            totalProdsValue.font = {
                bold: true
            }

            // totalProdsValue.border = {
            //     bottom: {style:'medium', color: {argb:'FF000000'}}
            // }

            // Write the updated workbook to a Blob and trigger a download
            const buffer = await workbook.xlsx.writeBuffer();
            const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
            saveAs(blob, `${fileName}.xlsx`);
        } catch (error) {
            console.error("Error updating and downloading the file:", error);
            alert("An error occurred while updating the Excel file.");
        }
    };

    return (
        <Button onClick={handleUpdateAndDownload}>
            <FontAwesomeIcon
                size="2xl"
                icon={faFileExcel}
                color={colors.greenAccent[600]}
            />
        </Button>
    );
};

export default ExcelUpdater;